import { render, staticRenderFns } from "./timeslot.vue?vue&type=template&id=18ff715a&"
import script from "./timeslot.vue?vue&type=script&lang=js&"
export * from "./timeslot.vue?vue&type=script&lang=js&"
import style0 from "./timeslot.vue?vue&type=style&index=0&id=18ff715a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports